<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="检查项" prop="checkItemId">
        <el-input
          v-model="queryParams.checkItemId"
          placeholder="请输入检查项"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate">修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete">删除</el-button>
      </el-col>
    </el-row>

    <el-table
        :data="scoreList"
        :header-cell-style="{ background: 'rgb(250,250,250)' }"
        style="width: 100%">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="检查项" align="center" prop="tbBaseCheckItem.checkName" />
      <el-table-column label="是否为否决项" align="center" prop="isReject" >
        <template slot-scope="{ row }">
          {{ row.isReject === 0 ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column label="扣分分值" align="center" prop="deductPoint" />
      <el-table-column label="扣分说明" align="center" prop="deductIllustrate" />
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)">修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    


    <!-- 添加或修改检查项评分细则对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-form-item label="检查项" prop="checkItemId">
          <el-select v-model="form.checkItemId" placeholder="请选择检查项">
            <el-option
                v-for="dict in itemList"
                :key="dict.id"
                :label="dict.checkName"
                :value="dict.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否为否决项" prop="isReject">
          <el-select v-model="form.isReject" style="width: 100%">
            <el-option :value="0" label="否"/>
            <el-option :value="1" label="是"/>
          </el-select>
        </el-form-item>
        <el-form-item label="扣分分值" prop="deductPoint">
          <el-input v-model="form.deductPoint" placeholder="请输入扣分分值" />
        </el-form-item>
        <el-form-item label="扣分说明" prop="deductIllustrate">
          <el-input v-model="form.deductIllustrate" type="textarea" placeholder="请输入内容" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listScore, getScore, delScore, addScore, updateScore } from "@/api/specialExamination/score";
import {listItem} from "@/api/specialExamination/item";

export default {
  name: "Score",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      curPage: 1,
      pageSize: 10,
      // 检查项评分细则表格数据
      scoreList: [],

      itemList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        id: null,
        checkItemId: null,
        isReject: null,
        deductPoint: null,
        deductIllustrate: null,
        delete: null,
        updateDate: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
    this.getItemList();
  },
  methods: {
    /** 查询检查项评分细则列表 */
    getList() {
      this.loading = true;
      listScore({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(response => {
        this.scoreList = response.body.data;
        this.total = response.body.cum
      });
    },
    getItemList(){
      listItem().then(response => {
        this.itemList = response.body.data
      })
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        checkItemId: null,
        isReject: null,
        deductPoint: null,
        deductIllustrate: null,
        delete: null,
        createTime: null,
        createBy: null,
        updateDate: null,
        updateBy: null
      };
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加检查项评分细则";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id
      getScore(id).then(response => {
        this.form = response.body.data;
        this.open = true;
        this.title = "修改检查项评分细则";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateScore(this.form).then(response => {
              this.open = false;
              this.getList();
            });
          } else {
            addScore(this.form).then(response => {
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      delScore(row.id).then(res => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
  }
};
</script>
